import { IFullWidthMedia } from '@models/IFullWidthMedia';
import { IMediaWithCaption } from '@models/IMediaWithCaption';
import MediaWithCaption from '@molecules/MediaWithCaption/MediaWithCaption';

const FullWidthMediaContent = (props: IMediaWithCaption) => (
  <div className="tw-relative tw-m-auto tw-w-full tw-max-w-screen-xxl">
    <MediaWithCaption {...props} />
  </div>
);

const FullWidthMedia = (props: IFullWidthMedia) => (
  <>
    {/* Display on full width layout */}
    <section className="group-[.rich-text--article]/article:tw-hidden">
      <FullWidthMediaContent {...props} />
    </section>
    {/* Display on article page, designed to break out of article max width */}
    <section className="columns--max-width-md--escape-with-gutter tw-hidden group-[.rich-text--article]/article:tw-block">
      <FullWidthMediaContent {...props} />
    </section>
  </>
);

export default FullWidthMedia;
